import Sankey from '../Sankey';

export { Sankey };
